import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudMarketgroupsService} from '@shared/services/crud-marketgroups.service';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {CrudMarketsService} from '@shared/services/crud-markets.service';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {CrudFlagsService} from '@shared/services/crud-flags.service';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AlertService} from '@shared/services/alert.service';


@Component({
  selector: 'app-marketgroups-edit',
  templateUrl: './marketgroups-edit.component.html',
  styleUrls: ['./marketgroups-edit.component.scss']
})
export class MarketgroupsEditComponent extends AbstractCrudEditComponent {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private marketgroupservice: CrudMarketgroupsService,
    private marketservice: CrudMarketsService,
    private flagservice: CrudFlagsService,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService
  ) {
    super(activatedRoute, router, apifactory, marketgroupservice, alertService);

    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12',
            fieldGroup: [
              {key: 'id', type: 'input', defaultValue: '', templateOptions: {label: 'ID', readonly: true}},
              {key: 'active', type: 'checkbox', defaultValue: false, templateOptions: {label: 'active'}},
              {key: 'label', type: 'input', defaultValue: '', templateOptions: {label: 'Market group label', required: true}},
              {
                key: 'mandantflags',
                type: 'ng-select2',
                templateOptions: {label: 'Related mandant flags (applied independently)', required: true, multiple: true, bindLabel: 'flagkey'},
                hooks: {
                  onInit: this.initListOfMandantFlags
                }
              },
              {
                key: 'markets',
                type: 'ng-select2',
                templateOptions: {label: 'Related markets', multiple: true},
                hooks: {
                  onInit: this.initListOfMarkets
                }
              }
            ]
          }
        ]
      }
    ];
    this.createSectionTitle = 'Create market group';
    this.updatePrefixTitle = 'Edit market group:';
    this.entityrooturl = '/admin/marketgroups';
  }

  // Should be an arrow function.
  initListOfMarkets = (field:any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    this.marketservice.getEntities().subscribe(data => {
      typedField.templateOptions.options = data['results'];
    });
  };


  initListOfMandantFlags = (field: any) => {
    const typedField : Required<FormlyFieldConfig> = field;
    this.flagservice.getFlagsByMandantFlagcategorykey().subscribe(data => {
      typedField.templateOptions.options = data['results'];
    });
  };

}
